import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthService } from './auth/services/auth.service';
import { ProfileComponent } from './dialogs/profile/profile.component';
import { RefreshService } from './services/refresh.service';

@Component({
  selector: 'opt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild(MatSidenavContainer) sidenav: MatSidenavContainer;

  public title: string;
  public isProfileOpened = false;
  public isMobile = false;
  public isTabletPortrait = false;

  public isLogoIconLoaded = false;
  public isLogoTextLoaded = false;

  private _isSidenavCollapsed = false;
  private _isSidenavOpen = false;
  private _subscriptions = new Subscription();

  constructor(
    private matIconRegistry: MatIconRegistry,
    public authService: AuthService,
    public refreshService: RefreshService,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {}

  get opened(): boolean {
    if (this.isMobile) {
      return this._isSidenavOpen;
    }
    return true;
  }

  get mode(): 'side' | 'over' {
    return this.isMobile ? 'over' : 'side';
  }

  get hasBackdrop(): boolean {
    return this.isMobile;
  }

  get disableClose(): boolean {
    return !this.isMobile;
  }

  get isLogoLoaded(): boolean {
    return this.isLogoIconLoaded && this.isLogoTextLoaded;
  }

  get featureFlags() {
    return environment.featureFlags;
  }

  get isSidenavCollapsed(): boolean {
    if (this.isMobile) {
      return false;
    }
    return this._isSidenavCollapsed;
  }

  set isSidenavCollapsed(value: boolean) {
    this._isSidenavCollapsed = value;
    this.sidenav?.updateContentMargins();
  }

  ngOnInit(): void {
    this.title = environment.projectName;
    this.matIconRegistry.setDefaultFontSetClass('material-icons-outlined');
    this._subscriptions.add(
      this.breakpointObserver
        .observe(['(min-width: 1350px)'])
        .subscribe((state) => (this.isSidenavCollapsed = !state.matches))
    );

    this._subscriptions.add(
      this.breakpointObserver
        .observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
        .subscribe((result) => {
          this.isMobile = result.matches;
        })
    );

    this._subscriptions.add(
      this.breakpointObserver
        .observe([Breakpoints.TabletPortrait])
        .subscribe((result) => {
          this.isTabletPortrait = result.matches;
        })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public onProfileClick(): void {
    const dialogRef = this.dialog.open(ProfileComponent);
    this.isProfileOpened = true;
    dialogRef.afterClosed().subscribe(() => {
      this.isProfileOpened = false;
    });
  }

  public onSidebarToggle(): void {
    if (this.isMobile) {
      this._isSidenavOpen = !this._isSidenavOpen;
    } else {
      this.isSidenavCollapsed = !this.isSidenavCollapsed;
    }
  }

  public onNavigate(): void {
    if (this.isMobile) {
      this._isSidenavOpen = false;
    }
  }
}
